export default __webpack_public_path__ + "static/media/delete_input.1ea05269.svg";